import gql from 'graphql-tag';

export const newsColorSlide = gql`
    fragment newsColorSlide on news_color_Entry {
        __typename
        id
        title
        newsLink
        backgroundColor
    }
`;

export const newsImageSlide = gql`
    fragment newsImageSlide on news_image_Entry {
        __typename
        id
        title
        newsLink
        newsImage {
            ... on assets_Asset {
                __typename
                url
                srcset(sizes: ["400w", "640w", "960w", "1280w"])
                width
                height
                description
            }
        }
    }
`;
